import Table from './Table';
import ActionBar from './Table';

export interface ITableConfig {
    rowCount: number;
    pageNumber: number;
    idField?: string;
    columns?: ITableColumn[];
}

export interface ITableColumn {
    name: string;
    mapping: string;
    type?: string;
    format?: (value: string) => string;
    onCellClick?: (row: object, value: string) => void;
    cellClassName?: string;
}

export { Table, ActionBar };



// WEBPACK FOOTER //
// ./src/components/common/table/index.ts